import { doRequest } from '@r1-frontend/do-request/index';
import { personalData } from '@r1-frontend/api-domru/esign/v1/esia/personal-data';

import { updateError, updateSuccess, updatingData } from '~/src/features/lk/PassportUpdate/store/actions';
import { TAppThunkDispatch } from '~/src/store';

/**
 * Обновляем персональные данные в биллинге
 */
export const updatePassportData = (gosuslugiCode: string) => async(dispatch: TAppThunkDispatch): Promise<void> => {
        dispatch(updatingData());

        const response = await doRequest.apiEsign<string>(personalData({
            esiaCode: gosuslugiCode,
            withValidation: true,
        }));

        if (response.isSuccess) {
            dispatch(updateSuccess());
        } else {
            dispatch(updateError({ isShowPassportUpdateButton: [403, 400].includes(Number(response.error.status)), errorMessage: response.error.message  }));
        }
};
